import { Airror } from '@air/errors';

export function isAirrorInstance(result: any): result is Airror<any, any> {
  return result instanceof Airror;
}
